module.exports = __webpack_public_path__ + "img/icon-team-2.6c6ddb4a.svg";